export default __webpack_public_path__ + "static/Panasonic_MN34229_Night_thumb-0137625a5ed00ab95d1d6de81fb6012c.webp";